import React from 'react';
import { Link } from 'react-router-dom';
import footerLogo from '../../assets/images/logo-alt.png';
import './styles.scss';

class Footer extends React.Component {
	render() {
		return (
			<footer className="footer">
				<div className="footer__wrapper container">
					<Link to='/' className="footer__logo-link">
						<img src={footerLogo} alt="" className="footer__logo"/>
					</Link>
					<p className="footer__text">Copyright Laboratorio Dorronsoro &reg; {new Date().getFullYear()}</p>
				</div>
			</footer>
		)
	}
};

export default Footer;

